<template>
	<v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-tabs
                v-model="aktivtab"
                color="primary"
								icons-and-text>
                <v-tab>
                  Bejelentkezés
									<v-icon>fa-sign-in-alt</v-icon>
                </v-tab>
                <v-tab>
                  Regisztráció
									<v-icon>fa-user-plus</v-icon>
                </v-tab>
                <v-tab-item>
                  <v-card-text>
                    <v-form>
                      <v-text-field
                        v-model="bejelentkezesmezo.email"
                        label="Email"
                        name="email"
                        type="text"
												prepend-inner-icon="fa-envelope"
                      ></v-text-field>

                      <v-text-field
                        v-model="bejelentkezesmezo.jelszo"
                        label="Jelszó"
                        name="jelszo"
                        type="password"
												prepend-inner-icon="fa-key"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded @click="bejelentkezes()">Bejelentkezés<v-icon>fa-sign-in-alt</v-icon></v-btn>
                  </v-card-actions>
                </v-tab-item>
                <v-tab-item>
                  <v-card-text>
                    <v-form>
                      <v-text-field
                        v-model="regisztraciomezo.nev"
                        label="Név"
                        name="nev"
                        type="text"
												prepend-inner-icon="fa-user"
                      ></v-text-field>
                      <v-text-field
                        v-model="regisztraciomezo.email"
                        label="Email"
                        name="email"
                        type="text"
												prepend-inner-icon="fa-envelope"
                      ></v-text-field>

                      <v-text-field
                        v-model="regisztraciomezo.jelszo"
                        label="Jelszó"
                        name="jelszo"
                        type="password"
												prepend-inner-icon="fa-key"
                      ></v-text-field>
                      <v-text-field
                        v-model="regisztraciomezo.jelszomegegyszer"
                        label="Jelszó ismétlése"
                        name="jelszoismetlese"
                        type="password"
												prepend-inner-icon="fa-key"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded @click="regisztracio()">Regisztráció<v-icon>fa-user-plus</v-icon></v-btn>
                  </v-card-actions>
                </v-tab-item>
              </v-tabs>

            </v-card>
             <v-snackbar
	        v-model="snackbar.megnyit"
	      >
	        {{ snackbar.szoveg }}
	        <v-btn
	          color="pink"
	          text
	          @click="snackbar.megnyit = false"
	        >
	          Bezár
	        </v-btn>
	      </v-snackbar>
          </v-flex>
        </v-layout>

      </v-container>

    </v-content>
</template>
<script>
	 import router from "../router"

	export default {
data: function () {
  	return {
      aktivtab: 0,
      bejelentkezesmezo: {
        email:"",
        jelszo:""
      },
      regisztraciomezo: {
        nev:"",
        email:"",
        jelszo:"",
        jelszomegegyszer:""
      },
  		snackbar:{
  			szoveg:"",
  			megnyit:false
  		}
  	}
  },
  methods: {
  	bejelentkezes: function(){this.axios.post(this.$store.state.backendeleres+"bejelentkezes", {email: this.bejelentkezesmezo.email, jelszo: this.bejelentkezesmezo.jelszo})
  		.then(response =>{
  			if(response.data.sikeresbejelentkezes){
      			this.$store.dispatch('bejelentkezesallasvaltas', true)
            this.axios.get(this.$store.state.backendeleres+"hitelesites/admin").then((response) =>{
              this.$store.commit('admin',response.data.admin);
            })
  				router.push('/csoportok');
  			}
  			else{
  				this.snackbar.szoveg=response.data.hiba;
  				this.snackbar.megnyit=true;
  			}
  		});
  	},
    regisztracio: function(){
      if(this.regisztraciomezo.jelszo==this.regisztraciomezo.jelszomegegyszer){
        if(this.regisztraciomezo.email!=""){
          if(this.regisztraciomezo.nev!=""){
            if(this.regisztraciomezo.jelszo!=""){
              this.axios.post(this.$store.state.backendeleres+"regisztracio",{email: this.regisztraciomezo.email, jelszo: this.regisztraciomezo.jelszo, jelszoismetles: this.regisztraciomezo.jelszomegegyszer, nev: this.regisztraciomezo.nev})
              .then(response =>{
                if(response.data.sikeresregisztracio){
                  this.snackbar.szoveg="A regisztráció sikeresen megtörtént. Kérem, jelentkezzen be!";
                  this.snackbar.megnyit=true;
                  this.aktivtab=0;
                }
                else{
                  this.snackbar.szoveg=response.data.hiba;
                  this.snackbar.megnyit=true;
                }
              })
            }
            else{
              this.snackbar.szoveg="Nem adta meg jelszavát";
              this.snackbar.megnyit=true;

            }
          }
          else{
            this.snackbar.szoveg="Nem adta meg nevét";
            this.snackbar.megnyit=true;

          }
        }
        else{
          this.snackbar.szoveg="Nem adta meg email címét!";
          this.snackbar.megnyit=true;
        }
      }
      else{
        this.snackbar.szoveg="A két jelszó nem egyezik"
        this.snackbar.megnyit=true;
      }
    }
  },
  mounted () {
  	if(this.$store.bejelentkezve){
  		router.push('/csoportok');
  	}
  }
 }
</script>
